import { useTranslation } from 'react-i18next';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';

export const CharactersLimit = ({ remainingCharacters }: { remainingCharacters: number }) => {
  const { t } = useTranslation();

  const textClass = remainingCharacters <= 0 ? 'text-destructive' : 'text-muted-foreground';

  return (
    <div
      className={`align-center fixed right-8 bottom-8 flex gap-1 text-sm leading-5 ${textClass}`}
    >
      <span className="hidden xl:inline">{t('ai_agents.characters_remaining')}</span>
      <InfoTooltip content={t('ai_agents.characters_remaining')}>
        <span className="min-w-8 text-right font-medium">{` ${remainingCharacters} `}</span>
      </InfoTooltip>
    </div>
  );
};
